import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { OpenUuidExwork } from '@shared/src/controllers/open/OpenUuidExwork';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentActionsDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentActionsDto';
import { AlertService } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-actions-transferdriver',
    templateUrl: './shared.external.cmr.agent.actions.transferdriver.component.html',
    styleUrls: ['./shared.external.cmr.agent.actions.transferdriver.component.scss']
})
export class SharedExternalCMRAgentActionsTransferDriverComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteController: OpenRouteController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __value: RouteCMRAgentActionsDto;
    @Input()
    public set value(value: RouteCMRAgentActionsDto) {
        if (this.__value === value)
            return;
        this.__value = value;
        this.wellcome()
    }
    public get value(): RouteCMRAgentActionsDto {
        return this.__value;
    }

    public wellcome() {
        if(this.value)
            this.loadDriverInfo();
    }

    public showChangeDriverDataInfo: boolean = false;

    public driverInfo: OpenUuidExwork;
    public loadDriverInfo(){
        if(this.value){
            this.openRouteController.getExwork(this.value.uuidExwork).subscribe(data => {
                this.driverInfo = data;
            });
        }
    }

    onChangeEditMode(editMode: boolean){
        this.showChangeDriverDataInfo = editMode;
    }
    onRefreshData() {
        this.loadDriverInfo();
        this.showChangeDriverDataInfo = false;
    }

    public getResourceChangeDriverDataInfo(): string {
        if(this.showChangeDriverDataInfo)
            return 'SHARED.EXTERNAL.CMR.ACTIONS.TRANSFERTOANOTHERDRIVER.CHANGEDRIVERDATAINFO.BACK';
        return 'SHARED.EXTERNAL.CMR.ACTIONS.TRANSFERTOANOTHERDRIVER.CHANGEDRIVERDATAINFO.GO';
    }
    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
